export default __webpack_public_path__ + "static/ef-diferencial-img-1-140e707d62cbfffaae1b26b4740bb07f.png";